function sortBy<T extends Record<string, any>>(collection: T[], key: string, dir: 'asc' | 'desc' = 'asc'): T[] {
    return collection.sort((a: T, b: T): number => {
        if (a[key] === b[key]) {
            return 0;
        }

        const compareResult = a[key] < b[key] ? -1 : 1;

        return dir === 'asc' ? compareResult : -compareResult;
    });
}

function convertFlatMapToNestedMap(flatMap: any): any {
    const nestedMap = {};

    Object.keys(flatMap).forEach(key => {
        insertFlatKeyToNestedMap(nestedMap, key, flatMap[key]);
    });

    return nestedMap;
}

function insertFlatKeyToNestedMap(map: any, key: string, value: any): void {
    const keyParts = key.split('.');

    if (keyParts.length === 1) {
        map[key] = value;

        return;
    }

    if (!(keyParts[0] in map)) {
        const nextKeyIsNumber = !isNaN(Number(keyParts[1]));
        map[keyParts[0]] = nextKeyIsNumber ? [] : {};
    }

    insertFlatKeyToNestedMap(map[keyParts[0]], keyParts.splice(1).join('.'), value);
}

function range(fromNumber: number, toNumber: number, step: number = 1): Array<number> {
    const result: number[] = [];

    if (step === 0) {
        throw new Error('Step cannot be 0');
    }

    if ((fromNumber < toNumber && step < 0) || (fromNumber > toNumber && step > 0)) {
        throw new Error('Step direction is incompatible with range bounds');
    }

    for (
        let current = fromNumber;
        step > 0 ? current <= toNumber : current >= toNumber;
        current += step
    ) {
        result.push(current);
    }

    return result;
}

function convertMapToFlat<T>(map: any): Array<T> {
    if (Array.isArray(map)) {
        return [...map];
    }

    const flat: Array<T> = [];

    Object.keys(map).forEach((key) => {
        flat.push(...convertMapToFlat<T>(map[key]));
    });

    return flat;
}

export {
    sortBy,
    convertFlatMapToNestedMap,
    range,
    convertMapToFlat,
};
